import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import "twin.macro"
import profile1 from "../../images/images11.jpg"
import "../Section/CSS.css"
const EmailSection = () => {
  return (
    <div
      style={{ backgroundImage: `url(${profile1})` }}
      tw=" text-2xl md:text-7xl flex flex-col  justify-center items-center 
       space-y-5 bg-cover bg-center bg-no-repeat text-center min-h-screen font-extrabold p-5   bg-gray-500 mx-auto "
    >
      <div tw="text-5xl text-white font-extrabold flex flex-auto mt-24">
        STAY UP TO DATE WITH OUR IDEAS, NEWS AND UPDATES
      </div>
      <div tw="text-4xl">
        <div tw=" md:mt-48">
          <label htmlFor="email" tw="text-black">
            Email :{" "}
          </label>
          <input
            type="email"
            name="email"
            placeholder="Email"
            tw="py-2 w-80 h-10 px-3 rounded-2xl "
          />
        </div>
      </div>
    </div>
  )
}

export default EmailSection
